export const HARDWARE_ELIGIBILITY_POLICY_URL = "https://policy.a2z.com/docs/44534/publication";

export const GENERATE_SUPPORT_TICKET_URL = "https://it.amazon.com/help";
